import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessage,
    SettingState,
    ValidationMessageType,
} from '@appblocks/codegeneration/types';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';
import * as simulator from './simulator';
import * as tios from './tios';

export default class LCDGraph extends BaseFeature {
    constructor() {
        super();
        this.name = 'LCD Graphing';
        this.id = 'lcd_graph';
        this.icon = 'BsGraphUp';
        this.requirements = [['TPP2W(G2)', 'TPP2W(G3)']];
        this.files = [
            'libraries/lcd/lcd_graph.tbh',
            'libraries/lcd/lcd_graph.tbs',
        ];

        const settings = [
            {
                id: 'ENABLED',
                name: 'LCD Graph Enabled',
                settingType: SettingType.OPTION,
                required: true,
                default: '0',
                options: [
                    {
                        name: 'Disabled',
                        value: '0',
                    },
                    {
                        name: 'Enabled',
                        value: '1',
                    },
                ],
            },
            {
                id: 'MINY',
                name: 'Minimum',
                settingType: SettingType.NUMBER,
                required: true,
                default: '-100',
            },
            {
                id: 'MAXY',
                name: 'Maximum',
                settingType: SettingType.NUMBER,
                required: true,
                default: '100',
            },
            {
                id: 'STARTX',
                name: 'X Position',
                settingType: SettingType.NUMBER,
                required: true,
                default: '0',
            },
            {
                id: 'STARTY',
                name: 'Y Position',
                settingType: SettingType.NUMBER,
                required: true,
                default: 0,
            },
            {
                id: 'WIDTH',
                name: 'Width of Graph',
                settingType: SettingType.NUMBER,
                required: true,
                min: 1,
                max: 320,
                helpText: 'LCD width is 320 so maximum is 320',
                default: 320,
            },
            {
                id: 'HEIGHT',
                name: 'Height of Graph',
                settingType: SettingType.NUMBER,
                required: true,
                max: 240,
                min: 1,
                helpText: 'LCD height is 240 so maximum is 240',
                default: 240,
            },
            {
                id: 'FILL',
                name: 'Fill Color',
                settingType: SettingType.COLOR,
                required: true,
                helpText: 'Graph fill color',
                default: '#00ff00',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getDependencies() {
        const dependencies = [
            'lcd',
        ];

        return dependencies;
    }

    validate(): Array<ValidationMessage> {
        const errors: Array<ValidationMessage> = [];

        const MIN = this.getSettingValue('MINY');
        const MAX = this.getSettingValue('MAXY');

        if (MAX < MIN) {
            errors.push({
                message: 'maximum cannot be less than minimum',
                messageType: ValidationMessageType.ERROR,
            });
        }

        return errors;
    }

    getState(settingId: string): SettingState {
        if (settingId !== 'ENABLED' && this.getSettingValue('ENABLED').toString() === '0') {
            return SettingState.HIDDEN;
        }
        return SettingState.ENABLED;
    }

    getCodeBlocks(): Array<CodeBlock> {
        if (this.project.runtime === 'simulator') {
            return simulator.getCodeBlocks(this);
        }
        return tios.getCodeBlocks(this);
    }
}
